<template>
  <view class="page-wrapper">
    <view wx:if="{{fuzzy}}" class="tab-container">
      <Tab
        tabList="{{fuzzyTabs}}"
        tabKey="{{dateType}}"
        bind:settabkey="setTabkey"
      />
    </view>
    <Calendar
      class="tab-content calendar"
      wx:class="{{ {visible:isExact, range:isRange, fuzzy:fuzzy } }}"
      type="{{calendar_type}}"
      value="{{select_date}}"
      minDate="{{minDate}}"
      maxDate="{{maxDate}}"
      maxRange="{{maxRange}}"
      subTexts="{{calendarSubTexts}}"
      bindconfirm="onConfirm"
    />
    <FuzzySelectDate
      class="tab-content"
      wx:class="{{ {visible:!isExact } }}"
      fuzzyDate="{{fuzzyDate}}"
      bindconfirm="onFuzzyConfirm"
    />
  </view>
</template>

<script>
  import { createPage } from '@mpxjs/core'
  import { 
    is,
    bridge,
    query as webxQuery,
    hashQuery
  } from '@didi/webx-js'
  import dayjs from 'dayjs'
  import webviewBridge from '@mpxjs/webview-bridge'

  const { navigateBack, postMessage } = webviewBridge
  const query = () => {
    return {
      ...webxQuery(),
      ...hashQuery(),
    }
  }
  const TITLE = '选择日期'
  const DATE_TYPE = {
    EXACT: 'exact',
    FUZZY: 'fuzzy',
  }
  const CALENDAR_TYPE = {
    SINGLE: 'single',
    RANGE: 'range',
  }
  const BIZ_TYPE = {
    TRAIN: 'train',
    FLIGHT: 'flight',
  }
  const TODAY = dayjs()

  createPage({
    data: {
      biz_type: BIZ_TYPE.TRAIN,
      select_date: [],
      calendar_type: CALENDAR_TYPE.SINGLE,
      dateType: DATE_TYPE.EXACT,
      minDate: Date.now(),
      maxDate: Date.now(),
      maxRange: 100,
      calendarSubTexts: [],
      fuzzyTabs: [{
        label: '精准日期',
        value: DATE_TYPE.EXACT,
      }, {
        label: '模糊日期',
        value: DATE_TYPE.FUZZY,
      }],
      fuzzy: false,
      fuzzyDate: null,
    },
    computed: {
      isExact() {
        return this.dateType === DATE_TYPE.EXACT
      },
      isRange() {
        return this.calendar_type === CALENDAR_TYPE.RANGE
      }
    },
    onLoad() {
      this.setQueryParams()
      this.setDefaultData()
      this.setTitle()
    },
    methods: {
      onBack(cbDate) {
        if(is('passenger')) {
          bridge.callHandler('setResultData', cbDate)
          bridge.closePage()
        }else if(is('miniprogram')) {
          postMessage({
            data: {
              type: 'yks-date',
              result: cbDate,
            },
            success (res) {
              console.log('postmessage成功回调, 结果：', res)
            }
          })
          navigateBack()
        }
      },
      onFuzzyConfirm({ detail }) {
        const {
          weeks = [],
          months = [],
        } = detail
        this.onBack({
          type: DATE_TYPE.FUZZY,
          data: {
            weeks: weeks.sort(),
            months: months.sort(),
          }
        })
      },
      onConfirm({ detail }) {
        if(this.calendar_type === CALENDAR_TYPE.SINGLE) {
          this.onBack({
            type: CALENDAR_TYPE.SINGLE,
            data: dayjs(detail[0]).format('YYYY-MM-DD')
          })
        }else if(this.calendar_type === CALENDAR_TYPE.RANGE) {
          this.select_date = [...detail]
          this.onBack({
            type: CALENDAR_TYPE.RANGE,
            data: detail.map(i => dayjs(i).format('YYYY-MM-DD'))
          })
        }
      },
      generateTrainSubdateArray() {
        const startDate = TODAY.add(15, 'd')
        const dates = []
        for (let i = 0; i < 45; i++) {
          dates.push({
            date: startDate.add(i, 'd').format('YYYY-MM-DD'),
            text: '预约'
          })
        }
        return dates
      },
      setDefaultData() {
        let MAX_DAYS = 365-1
        if(this.biz_type === BIZ_TYPE.TRAIN) {
          MAX_DAYS = 60-1
          this.calendarSubTexts = this.generateTrainSubdateArray()
        }
        this.minDate = TODAY.format('YYYY-MM-DD') 
        this.maxDate = TODAY.add(MAX_DAYS, 'd').format('YYYY-MM-DD')
      },
      setQueryParams() {
        const params = query()
        let {
          biz_type = BIZ_TYPE.TRAIN, // 业务类型
          calendar_type = CALENDAR_TYPE.SINGLE, // 日历类型
          select_date = JSON.stringify([TODAY.format('YYYY-MM-DD')]), // 选中日期
          fuzzy = '', // 是否支持模糊选择
          fuzzy_date = null, //
        } = params
        this.biz_type = biz_type
        this.calendar_type = calendar_type
        this.fuzzy = fuzzy === '1'
        this.fuzzyDate = fuzzy_date ? JSON.parse(fuzzy_date) : null

        // 选中的日期
        this.select_date = calendar_type === CALENDAR_TYPE.SINGLE
          ? [JSON.parse(select_date)[0]]
          : JSON.parse(select_date)
        
        // 精准 or 模糊 日期查询
        this.setTabkey({
          detail: (fuzzy && fuzzy_date)
            ? DATE_TYPE.FUZZY
            : DATE_TYPE.EXACT
        })
      },
      setTabkey({ detail }) {
        this.dateType = detail
      },
      setTitle() {
        document.title = TITLE
        if(is('passenger')) {
          bridge.setTitle({
            title: TITLE
          })
          bridge.updateNaviView({
            shadowhidden: 1,
          })
        }
      }
    }
  })
</script>

<script name='json'>
  module.exports = {
    usingComponents: {
      'Tab': '@didi/spring-ui/tab',
      'Calendar': '@didi/spring-ui/calendar',
      'FuzzySelectDate': '@/components/calendar-popup/fuzzy-select-date.mpx',
    }
  }
</script>

<style lang="stylus" scoped>
.page-wrapper
  height 100vh
  background-color #fff
  .tab-container
    overflow hidden
    background-color #fff
  .tab-content
    position absolute
    visibility hidden
    z-index -1
    &.calendar
      >>> .calendar-body
        height calc(100vh - 40px)
      &.range
        >>> .calendar-body
          height calc(100vh - 160px)
      &.fuzzy
        >>> .calendar-body
          height calc(100vh - 100px)
      &.fuzzy.range
        >>> .calendar-body
          height calc(100vh - 216px)
    &.visible
      position static
      visibility visible
</style>